module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption-head"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "caption-head-icon"
  }, [_c('span', {
    staticClass: "active-chevron"
  }, [_c('icon', {
    attrs: {
      "name": "chevron-up"
    }
  })], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption-head-text"
  }, [_c('span', [_vm._v("Last Edited")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-106237d6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/newCmsStyle/ComponentArticle/lastEditedArticles.vue
// module id = 943
// module chunks = 0